import { Box } from "@mui/material";

function Referral() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        padding: "150px 0px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      Referral Forms Coming Soon...
    </Box>
  );
}

export default Referral;
